// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d86bf958","orgContainer":"f31b1eb4","orgRow":"e6b45bb4","leftCol":"fda863b2","orgName":"faf6bd50","id":"d0db6cab","count":"f3c0a809"};